export const COLOR_GREY = '#3a3a3c';
export const COLOR_YELLOW = '#b59f3b';
export const COLOR_GREEN = '#538d4e';
